import {formatTableData} from 'utils/util';

const GET_ACCOUNTFLOW_LIST_START = 'zb/GET_ACCOUNTFLOW_LIST_START';
const GET_ACCOUNTFLOW_LIST_SUCCESS = 'zb/GET_ACCOUNTFLOW_LIST_SUCCESS';
const GET_ACCOUNTFLOW_LIST_FAILED = 'zb/GET_ACCOUNTFLOW_LIST_FAILED';

let initialState = {
  accountFlowList: [],
  total: 0
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case GET_ACCOUNTFLOW_LIST_SUCCESS:
      return {
        ...state,
        accountFlowList: formatTableData(action.resp.data && action.resp.data.list || []),
        total: action.resp.data && action.resp.data.total
      };
    default:
      return state;
  }
}

export function getAccountFlowList(data = {}) {
  return {
    types: [GET_ACCOUNTFLOW_LIST_START, GET_ACCOUNTFLOW_LIST_SUCCESS, GET_ACCOUNTFLOW_LIST_FAILED],
    promise: (client) => client.get('bill/flow/flowList', {
      params: data,
    })
  };
}
